<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const props = defineProps({
  size: { type: [Number, String], default: 16 },
});

let counter = 0;
// eslint-disable-next-line no-plusplus
const uid = computed(() => `cmci-${++counter}-${props.size}`);
const bubId = computed(() => `bub-${uid.value}`);
const igId = computed(() => `ig-${uid.value}`);

const stats = useMapGetter('conversationStats/getStats');
const count = computed(() => stats.value?.allCount || 0);
const displayCount = computed(() => (count.value > 99 ? '99+' : String(count.value)));
</script>

<template>
  <span class="relative inline-flex" :style="{ width: `${size}px`, height: `${size}px` }">
    <svg
      :width="size"
      :height="size"
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <linearGradient :id="bubId" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="#f8fafc" />
          <stop offset="100%" stop-color="#cbd5e1" />
        </linearGradient>
        <linearGradient :id="igId" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="#833AB4" />
          <stop offset="50%" stop-color="#E1306C" />
          <stop offset="100%" stop-color="#FCAF45" />
        </linearGradient>
      </defs>

      <path
        d="M11 11 a4 4 0 014-4 h12 a4 4 0 014 4 v9 a4 4 0 01-4 4 h-7 l-4 4 v-4 a4 4 0 01-4-4z"
        :fill="`url(#${bubId})`"
      />
      <circle cx="18" cy="15.5" r="1.1" fill="#475569" />
      <circle cx="21" cy="15.5" r="1.1" fill="#475569" />
      <circle cx="24" cy="15.5" r="1.1" fill="#475569" />

      <circle cx="8" cy="8" r="2.4" fill="#25D366" />
      <circle cx="32" cy="8" r="2.4" :fill="`url(#${igId})`" />
      <circle cx="8" cy="32" r="2.4" fill="#1877F2" />
      <circle cx="32" cy="32" r="2.4" fill="#000" />
      <circle cx="32" cy="32" r="0.8" fill="#00f2ea" />
    </svg>

    <!-- Badge M1.B · 2026-05-19 (Victor): punto dorado con glow + número fino
         dorado, sin pastilla roja (Propuesta 2). -->
    <span
      v-if="count > 0"
      class="absolute -top-1.5 -right-3 flex items-center gap-[3px] leading-none pointer-events-none tabular-nums"
    >
      <span
        class="size-[7px] rounded-full bg-[#d4af6a] shadow-[0_0_7px_rgba(212,175,106,0.9)]"
      />
      <span class="text-[9px] font-bold text-[#d4af6a]">{{ displayCount }}</span>
    </span>
  </span>
</template>
